// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"47":"e01ddeb1","315":"456cfaff","923":"2cd6b09d"}[chunkId] + ".chunk.js";
};